var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#216cd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1557b2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7e14b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7df3e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e12539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca192c"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.38095238 0h5.33333332v3.42187827c0 .42448491-.25569119.98776181-.57862693 1.26456388l-1.21487332 1.04131998c-.48223649.41334557-1.26664225.41116333-1.7463328 0l-1.21487332-1.04131998c-.31956684-.27391444-.57862695-.83889021-.57862695-1.26456388z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.38095238 0h5.33333332v3.42187827c0 .42448491-.25569119.98776181-.57862693 1.26456388l-1.21487332 1.04131998c-.48223649.41334557-1.26664225.41116333-1.7463328 0l-1.21487332-1.04131998c-.31956684-.27391444-.57862695-.83889021-.57862695-1.26456388z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.38095238 0h5.33333332v3.42187827c0 .42448491-.25569119.98776181-.57862693 1.26456388l-1.21487332 1.04131998c-.48223649.41334557-1.26664225.41116333-1.7463328 0l-1.21487332-1.04131998c-.31956684-.27391444-.57862695-.83889021-.57862695-1.26456388z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.38095238 0h5.33333332v3.42187827c0 .42448491-.25569119.98776181-.57862693 1.26456388l-1.21487332 1.04131998c-.48223649.41334557-1.26664225.41116333-1.7463328 0l-1.21487332-1.04131998c-.31956684-.27391444-.57862695-.83889021-.57862695-1.26456388z",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    fillRule: "nonzero",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(4.952381 3.809524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.38095238 0h5.33333332v3.42187827c0 .42448491-.25569119.98776181-.57862693 1.26456388l-1.21487332 1.04131998c-.48223649.41334557-1.26664225.41116333-1.7463328 0l-1.21487332-1.04131998c-.31956684-.27391444-.57862695-.83889021-.57862695-1.26456388z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.52380952 1.52380952c-.21039418 0-.38095238-.17055819-.38095238-.38095238 0-.21039418.1705582-.38095238.38095238-.38095238.21039419 0 .38095238.1705582.38095238.38095238 0 .21039419-.17055819.38095238-.38095238.38095238zm1.52380953 0c-.21039419 0-.38095238-.17055819-.38095238-.38095238 0-.21039418.17055819-.38095238.38095238-.38095238.21039418 0 .38095238.1705582.38095238.38095238 0 .21039419-.1705582.38095238-.38095238.38095238zm1.52380952 0c-.21039419 0-.38095238-.17055819-.38095238-.38095238 0-.21039418.17055819-.38095238.38095238-.38095238s.38095238.1705582.38095238.38095238c0 .21039419-.17055819.38095238-.38095238.38095238z",
    fill: "url(#d)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.9047619 4.95238095c-.21039418 0-.38095238-.17055819-.38095238-.38095238s.1705582-.38095238.38095238-.38095238c.21039419 0 .38095239.17055819.38095239.38095238s-.1705582.38095238-.38095239.38095238zm1.14285715.38095238c-.21039419 0-.38095238-.17055819-.38095238-.38095238 0-.21039418.17055819-.38095238.38095238-.38095238.21039418 0 .38095238.1705582.38095238.38095238 0 .21039419-.1705582.38095238-.38095238.38095238zm1.14285714-.38095238c-.21039419 0-.38095238-.17055819-.38095238-.38095238s.17055819-.38095238.38095238-.38095238.38095238.17055819.38095238.38095238-.17055819.38095238-.38095238.38095238z",
    fill: "url(#d)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.380952 2.285714h5.333333v1.52381h-5.333333z",
    fill: "url(#e)",
    mask: "url(#i)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.047619,
    cy: 3.047619,
    fill: "#fff",
    mask: "url(#j)",
    r: 1
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.95238095 2.66666667s1.52380953-.38095238 3.04761905-.38095238 3.047619.38095238 3.047619.38095238l-.3809523 1.52380952s-1.33333337-.38095238-2.6666667-.38095238-2.66666667.38095238-2.66666667.38095238z",
    fill: "url(#d)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 3.42857143c-.21039421 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.17055817-.38095238.38095238-.38095238s.38095238.17055819.38095238.38095238c0 .21039418-.17055817.38095238-.38095238.38095238zm1.52380952 0c-.21039421 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.17055817-.38095238.38095238-.38095238s.38095238.17055819.38095238.38095238c0 .21039418-.17055817.38095238-.38095238.38095238zm-3.04761904 0c-.21039419 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.17055819-.38095238.38095238-.38095238.21039418 0 .38095238.17055819.38095238.38095238 0 .21039418-.1705582.38095238-.38095238.38095238z",
    fill: "#5e5216",
    mask: "url(#f)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBl);
export default __webpack_public_path__ + "static/media/BL.d9c2d9b6a1ea578c17db170c26d25358.svg";
export { ForwardRef as ReactComponent };